import Flex from '~/common/components/Flex';
import { RULE_CATEGORY_ID } from '~/common/constants';
import { useUser } from '~/common/hooks/useAuthentication';
import AISwitchToggle from '~/common/mui/Switch/SwitchAI/AISwitchToggle.tsx';
import CalculationHistory from '~/pages/IncomeCalculator/CalculationHistory/CalculationHistory';
import { CalculationTypes } from '~/pages/IncomeCalculator/enums';
import { useSelectedAlert } from '~/stores/navigationStore';

type PageHeaderProps = {
  title?: string;
  isTitleHidden?: boolean;
  isAiSwitchButtonEnabled?: boolean;
};

export default function PageHeader({
  title,
  isTitleHidden = false,
  isAiSwitchButtonEnabled = false,
}: Readonly<PageHeaderProps>) {
  const selectedAlert = useSelectedAlert();
  const { isUnderwriter } = useUser();
  const shouldShowCalculationHistory =
    selectedAlert?.ruleCategoryId === RULE_CATEGORY_ID.INCOME &&
    (selectedAlert?.additionalReferences?.IsSDUI === 'True' ||
      selectedAlert?.additionalReferences?.CalculatorTypeId ==
        CalculationTypes.PayStub.toString());

  const pageTitle = title || selectedAlert?.displayTitle;
  const displayTitle = isTitleHidden ? '' : (pageTitle ?? '');

  return (
    <Flex
      id="page-header"
      data-testid="page-header"
      justifyContent="space-between"
      p={4}
      pl={8}
      sx={{
        borderBottom: '1px solid',
        borderColor: 'gray.200',
        padding: '1rem',
        paddingLeft: '2rem',
        justifyContent: 'space-between',
      }}
    >
      {displayTitle && (
        <h2 id="page-title" data-testid="page-title">
          {displayTitle}
        </h2>
      )}
      <Flex>
        {shouldShowCalculationHistory && (
          <CalculationHistory sx={{ marginRight: '1rem' }} />
        )}
        {isAiSwitchButtonEnabled && isUnderwriter && (
          <AISwitchToggle sessionStorageEnabled />
        )}
      </Flex>
    </Flex>
  );
}
